<template>
    <div>
        <div v-if="options_loaded && passed_filter && panel_required">
            <div class="designeroption" :data-designer-component-id="component_id">
                <h3 v-if="maintitle != ''">
                    {{ maintitle }}
                  <designer-question-popup-info
                      v-if="has_popup_info"
                      :popup_info_title_html="popup_info_title_html"
                      :popup_info_inner_html="popup_info_inner_html"
                  ></designer-question-popup-info>
                </h3>
                <div class="designer-floating-sidebar-message" v-if="floating_sidebar_message">
                    <i class="fa fa-circle-question"></i>
                    <span v-html="floating_sidebar_message"></span>
                </div>
                <div class="stylesoption">
                    <div class="form-group" :class="[!valid_selection ? 'has-error' : '']">
                        <label :for="'question--' + component_id" v-show="maintitle == ''">{{ title }}</label>
                        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                        </select>
                        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                            <option>Loading Options...</option>
                        </select>
                    </div>
                    <div v-if="extra_html !== null" v-html="extra_html"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import {nextTick} from "vue";
    import DoorDesignerOptions from "./DoorDesignerOptions.vue";
    import DesignerQuestionPopupInfo from "../DesignerQuestionPopupInfo.vue";

    export default {
        emits: ['update:target'],
        components: {
            DesignerQuestionPopupInfo,
        },
        mixins: [
            DoorDesignerOptions,
        ],
        props: {
            target: {
                required: true,
            },
            fabricator: {
                required: true,
            },
            title: {
                default() {
                    return '';
                }
            },
            maintitle: {
                default() {
                    return '';
                }
            },
            component_id: {
                required: false,
            },
            componentFilterBox: {
                default() {
                    return false;
                }
            },
            filterSearch: {
                default() {
                    return '';
                }
            },
            helper_text: {
              required: false,
            },
            has_popup_info: {
              default(){
                return false;
              }
            },
            popup_info_title_html: {
              default(){
                return '';
              }
            },
            popup_info_inner_html: {
              default(){
                return '';
              }
            },
            extra_html: {
                default(){
                    return null;
                }
            },
            floating_sidebar_message: {
                default(){
                    return '';
                }
            },
            select_first_after_update_prop: {
                default(){
                    return false;
                }
            },
        },
        data() {
            return {
                optionsRequestController: null,
                option_list: null,
                cache: {},
                loading: false,
                select_first_after_update: false,
                update_options: window._.debounce((callback) => {
                    var cache_key = this.cache_key;
                    var url = this.url;

                    if (!this.passed_filter) {
                        if (!this.valid_selection) {
                            this.select_first();
                        }
                        if (callback !== undefined) {
                            callback();
                        }
                        return;
                    }
                    if (this.cache[cache_key] !== undefined) {
                        this.option_list = this.cache[cache_key];
                        if (!this.valid_selection) {
                            this.select_first();
                        }
                        if (callback !== undefined) {
                            callback();
                        }
                        if(this.select_first_after_update) {
                            this.select_first_after_update = false;
                            this.select_first();
                        }
                        return;
                    }

                    this.loading = true;

                    if (this.optionsRequestController) {
                        this.optionsRequestController.abort();
                    }

                    const controller = new AbortController();
                    this.optionsRequestController = controller;

                    const id = crypto.randomUUID();

                    window.emitter.emit('request-count-inc', {url, id});

                    window.axios.get(url, {
                        signal: controller.signal,
                    }).then(response => {
                        if (this.optionsRequestController === controller) {
                            this.optionsRequestController = null;
                        }
                        this.cache[cache_key] = response.data;
                        this.loading = false;
                        this.update_options(callback);
                        window.emitter.emit('update-navigation');
                        window.emitter.emit('request-count-dec', {url, id, reason: 'success'});
                    }).catch((error) => {
                        if (error?.code === 'ERR_CANCELED') {
                            window.emitter.emit('request-count-dec', {url, id, reason: 'canceled'});
                            return;
                        }

                        window.emitter.emit('request-count-dec', {url, id, reason: 'error'});
                        if (this.optionsRequestController === controller) {
                            this.optionsRequestController = null;
                        }
                        this.loading = false;
                    });
                }, 300)
            };
        },
        watch: {
            'valid_selection': {
                handler: function (is_valid, was_valid) {
                    if (!is_valid && this.options_loaded) {
                        this.select_first();
                    }
                },
                deep: true
            },
            'options_loaded': {
                handler: function (loaded, was_valid) {
                    if (loaded && !this.valid_selection) {
                        this.select_first();
                    }
                },
                deep: true
            },
        },
        computed: {
            localTarget: {
                get() {
                    return this.target
                },
                set(val) {
                    if(this.target !== val) {
                        this.$emit('update:target', val)
                    }
                }
            },
            panel_required(){
                return this.filtered_option_list.length > 0
            },
            filtered_option_list() {
                if (Array.isArray(this.option_list)) {
                    return this.option_list.filter((key) => {
                        return key.value !== null && (~key.label.toLowerCase().indexOf(this.filterSearch.toLowerCase()) || key.value === this.localTarget);
                    });
                } else {
                    return [];
                }
            },
            valid_selection() {
                if (!this.options_loaded) {
                    return false;
                }
                return this.localTarget !== null && this.localTarget !== undefined && (this.filtered_option_list.find(y => {
                    return y.value == this.localTarget;
                }) !== undefined);
            },
            passed_filter() {
                return true;
            },
            options_loaded() {
                return !this.loading && Array.isArray(this.option_list);
            },
        },
        methods: {
            variable_ready(...vars) {
                var found_value = vars.findIndex((val) => {
                    return val === undefined || val === null;
                });

                return found_value === -1;
            },
            select_first() {
                nextTick(() => {
                    if (!this.options_loaded) {
                        // Nothing to do
                        return;
                    }
                    if ((this.filtered_option_list.length === 0)) {
                        this.localTarget = undefined;
                        return;
                    }

                    var new_value = this.filtered_option_list[0];

                    this.localTarget = new_value.value;
                });
            }
        },
        mounted() {
            if (this.passed_filter) {
                this.update_options();
            }

            window.emitter.on('new-door', (door, reference_on = true) => {
                this.cache = {};
                this.option_list = null;
                nextTick(() => {
                    if (this.passed_filter) {
                        this.update_options();
                    }
                });
            });

        },
        unmounted() {
            if (this.optionsRequestController) {
                this.optionsRequestController.abort();
                this.optionsRequestController = null;
            }
        },
    }
</script>
